import { track as _trackOriginal, TrackingProp, useTracking } from 'react-tracking'

import { User } from '@/types/user'

export { TrackingProp, _trackOriginal as track, useTracking }

/** Gets the type for the 4th parameter of the @track decorator */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AsyncTrackResult<F extends (...args: any[]) => any> = [Awaited<ReturnType<F>>] | [undefined, unknown]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnalyticsResponse<T = any> = { action: string } & { [K in keyof T]: T[K] }

export function trackEvent<T extends { action: string }>(trackingInfo: T): void {
	// GTM Tracking disabled
	void trackingInfo
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type WithTracking<P = {}, S = any> = P & { tracking: TrackingProp<S> }

export function sendUserFetchedEvent(user: User) {
	trackEvent({ event: 'ts-user-fetched', user, action: 'User Fetched' })
}
